// Servis nářadí (issue #38, screens/13-servis.md + m13-servis.md,
// mockupy design/„Servis nářadí.dc.html" a „Servis nářadí mobil.dc.html").
//
// Nativní stránka je `type-page` s prostým textem z administrace — tvar
// obsahu a parsery jsou od 2026-09-02 v `serviceModel.js`, protože tutéž
// stránku destiluje i modal servisu na detailu produktu (serviceModal.js).
// Všechny bloky designu se z toho dají POSTAVIT — ceny, značky i popisy proto
// čteme z reálného obsahu, ne z konstant. Když klient text v adminu změní,
// změní se i stránka; když sekce zmizí, blok se vypustí.
//
// ODCHYLKY OD SPECKY (ověřeno na dev instanci 2026-07-29):
//   • Design má H1 „Opravíme vaše nářadí rychle a za férové ceny" — nativní H1
//     je „Servis nářadí" (SEO nadpis stránky) a nepřepisujeme ho. Marketingová
//     věta z obsahu jde do perexu jako tučný úvod.
//   • Fotka servisní dílny (image-slot `servis-hero`) na CDN není (dodá klient),
//     hero je proto jednosloupcové a plovoucí karta „Záruka na opravy" stojí
//     pod CTA řadou.
//   • Wordmarky značek jsou reálné (10 značek z obsahu), ne 6 z návrhu.

import { icon } from './icon.js';
import { CONTACT, telHref } from './headerTools.js';
import {
  LABEL_EYEBROW,
  LABEL_SPEC,
  LABEL_PRICE_PEREX,
  LABEL_BAND_TITLE,
  LABEL_BAND_TEXT,
  parseServiceContent,
} from './serviceModel.js';
import {
  el,
  link,
  textOf,
  iconBox,
  pageHost,
  pageIs,
  markReady,
  buildHero,
  buildBadge,
  sectionHead,
  centerHead,
  buildCtaBand,
} from './infoPage.js';
import { page } from './pages.js';
import L from '../locale/cs/servicePage.js';

// Texty → locale vrstva (S3 #399); dluh per soubor měří tools/lib/locale-debt.mjs (sdílené s modalem v serviceModel.js)
const LABEL_ORDER = L.order;
const LABEL_PRICELIST = L.pricelist;
const LABEL_WARRANTY = L.warranty;
const LABEL_WARRANTY_SUB = L.warrantySub;
const LABEL_SERVICES_HINT = L.servicesHint;
const LABEL_NO_FEES = L.noFees;
const LABEL_BAND_MAIL = L.bandMail;
const LABEL_SERVICES = L.services;
const LABEL_PRICING = L.pricing;
const LABEL_WHY = L.why;

// ---------------------------------------------------------------------------
// Stavba
// ---------------------------------------------------------------------------
function buildBrandStrip(claim, brands) {
  if (!claim && !brands.length) return null;
  const strip = el('section', 'bs-svc__brands');
  if (claim) {
    // mockup má „Servis všech značek" tučně a BEZ zelené fajfky (#29);
    // z administrace přichází fragment věty, tedy malým písmenem
    const all = el('span', 'bs-svc__brands-claim');
    all.appendChild(el('span', null, claim.charAt(0).toUpperCase() + claim.slice(1)));
    strip.appendChild(all);
  }
  if (brands.length) {
    if (claim) strip.appendChild(el('span', 'bs-svc__brands-sep'));
    strip.appendChild(el('span', 'bs-svc__brands-label', LABEL_SPEC));
    const list = el('div', 'bs-svc__brands-list');
    brands.forEach(function (name) {
      list.appendChild(el('span', 'bs-svc__wordmark', name));
    });
    strip.appendChild(list);
  }
  return strip;
}

function buildServices(section) {
  if (!section.items.length) return null;
  const wrap = el('section', 'bs-ip__sec');
  wrap.appendChild(sectionHead(textOf(section.heading) || LABEL_SERVICES, LABEL_SERVICES_HINT));

  const grid = el('div', 'bs-svc__grid');
  section.items.forEach(function (item) {
    const tile = item.href ? link(item.href, 'bs-svc__tile bs-svc__tile--link') : el('div', 'bs-svc__tile');
    const top = el('div', 'bs-svc__tile-top');
    top.appendChild(iconBox(item.icon, 'bs-svc__tile-icon'));
    if (item.chip) top.appendChild(el('span', 'bs-svc__chip', item.chip));
    tile.appendChild(top);
    tile.appendChild(el('div', 'bs-svc__tile-name', item.title));
    if (item.desc) tile.appendChild(el('div', 'bs-svc__tile-desc', item.desc));
    grid.appendChild(tile);
  });
  wrap.appendChild(grid);
  return wrap;
}

// „od 1 200 Kč" → malé „od" před částkou (ceny jsou orientační, 2026-09-09)
function priceValue(item, cls, fromCls) {
  const parts = { prefix: item.priceFrom, value: item.priceAmount };
  const box = el('div', cls);
  if (parts.prefix) {
    box.appendChild(el('small', fromCls, parts.prefix));
    box.appendChild(document.createTextNode(' '));
  }
  box.appendChild(el('span', null, parts.value));
  return box;
}

function buildPricing(section, quick) {
  if (!section.items.length) return null;
  const wrap = el('section', 'bs-svc__pricing');
  wrap.id = 'cenik';

  const head = el('div', 'bs-svc__pricing-head');
  const headText = el('div');
  headText.appendChild(el('h2', 'bs-svc__pricing-title', textOf(section.heading) || LABEL_PRICING));
  headText.appendChild(el('p', 'bs-svc__pricing-perex', LABEL_PRICE_PEREX));
  head.appendChild(headText);
  const pill = el('span', 'bs-svc__pill');
  pill.appendChild(icon('check'));
  pill.appendChild(el('span', null, LABEL_NO_FEES));
  head.appendChild(pill);
  wrap.appendChild(head);

  const grid = el('div', 'bs-svc__price-grid');
  section.items.forEach(function (item) {
    const card = el('div', 'bs-svc__price');
    card.appendChild(iconBox(item.icon, 'bs-svc__price-icon'));
    card.appendChild(el('div', 'bs-svc__price-name', item.title));
    card.appendChild(priceValue(item, 'bs-svc__price-value', 'bs-svc__price-from'));
    if (item.note) card.appendChild(el('div', 'bs-svc__price-note', item.note));
    grid.appendChild(card);
  });
  wrap.appendChild(grid);

  if (quick.length) {
    const rows = el('div', 'bs-svc__quick');
    quick.forEach(function (item) {
      const row = el('div', 'bs-svc__qrow');
      row.appendChild(iconBox(item.icon, 'bs-svc__qrow-icon'));
      row.appendChild(el('span', 'bs-svc__qrow-name', item.title));
      const value = el('span', 'bs-svc__qrow-price' + (L.freeRe.test(item.chip) ? ' is-free' : ''), item.chip);
      row.appendChild(value);
      rows.appendChild(row);
    });
    wrap.appendChild(rows);
  }
  return wrap;
}

function buildWhy(section) {
  if (!section.items.length) return null;
  const wrap = el('section', 'bs-ip__sec');
  wrap.appendChild(centerHead(textOf(section.heading) || LABEL_WHY));
  const grid = el('div', 'bs-svc__why');
  section.items.forEach(function (item) {
    const cell = el('div', 'bs-svc__why-item');
    cell.appendChild(iconBox(item.icon, 'bs-svc__why-icon'));
    cell.appendChild(el('div', 'bs-svc__why-name', item.title));
    if (item.desc) cell.appendChild(el('div', 'bs-svc__why-desc', item.desc));
    grid.appendChild(cell);
  });
  wrap.appendChild(grid);
  return wrap;
}

// ---------------------------------------------------------------------------
export function initServicePage() {
  if (!pageIs('service')) return;
  const host = pageHost();
  if (!host || document.querySelector('.bs-svc')) return;

  const model = parseServiceContent(host.about);
  const services = model.services;
  const pricing = model.pricing;
  const why = model.why;
  const brands = model.brands;
  const claim = model.claim;
  const lead = model.lead;
  // ceníkové drobnosti (broušení, rady) = položky servisu, které mají cenový chip
  const quick = model.quick;

  // bez rozpoznaného obsahu nic nepřestavujeme — nativní text zůstane čitelný
  if (!services.items.length && !pricing.items.length) return;

  const root = el('div', 'bs-ip bs-svc');

  const perex = el('p');
  if (lead && lead.lead) perex.appendChild(el('b', null, lead.lead));
  if (lead && lead.rest) perex.appendChild(document.createTextNode((lead.lead ? ' ' : '') + lead.rest));

  const hero = buildHero({
    eyebrow: LABEL_EYEBROW,
    title: host.h1 || null,
    perex: lead ? perex : null,
    ctas: [
      { href: page('contact'), label: LABEL_ORDER, icon: 'cog', variant: 'primary' },
      { href: '#cenik', label: LABEL_PRICELIST, icon: 'tag', variant: 'outline' },
    ],
  });
  hero.appendChild(buildBadge({ icon: 'shield', title: LABEL_WARRANTY, text: LABEL_WARRANTY_SUB }));
  root.appendChild(hero);

  const strip = buildBrandStrip(claim.text, brands.names);
  if (strip) root.appendChild(strip);

  const blocks = [buildServices(services), buildPricing(pricing, quick), buildWhy(why)];
  blocks.forEach(function (block) {
    if (block) root.appendChild(block);
  });

  root.appendChild(
    buildCtaBand({
      icon: 'headset',
      title: LABEL_BAND_TITLE,
      text: LABEL_BAND_TEXT,
      // kanály v pořadí chat → e-mail → telefon (chatActions, phoneAction)
      actions: [
        { chat: 'service', variant: 'primary' },
        { href: page('contact'), label: LABEL_BAND_MAIL, icon: 'mail', variant: 'primary', chatVariant: 'outline' },
        {
          href: telHref(CONTACT.phone),
          label: CONTACT.phone,
          icon: 'phone',
          variant: 'ink',
        },
      ],
    })
  );

  // nativní text zůstává v DOM (schová ho CSS), ať je bez JS stránka čitelná
  host.about.classList.add('bs-ip__native');
  host.about.insertAdjacentElement('beforebegin', root);
  markReady();
}
